// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3havu","importantInfo":"styles_importantInfo__286vA"};